export const settings = {
  filteringTags:[],
  codeStyle:'okaidia'
}